export const getBrackground = (colors, background) => {
  return background === 'none' ? 'transparent' :
  // eslint-disable-next-line sonarjs/no-nested-conditional
  background ? colors[background] : undefined;
};